<template>
  <div class="task">
    <div class="pos-top">
      <new-head zai="false" title="我的任务" :isBack="false">
        <!-- <template slot="right">
          <span @click="screenShow = true">
            <van-icon size="24" style="font-weight: 900" name="search" />
          </span>
        </template> -->
      </new-head>
      <my-tabs v-model="navIndex" :navList="navList"></my-tabs>
      <div class="receiveNav" v-if="navIndex == 1">
        <div
          class="receiveNavItem"
          v-for="(item, i) in receiveNavList"
          :key="i"
          :class="{ receiveNavItemActive: receiveNavIndex == i }"
          @click="receiveNavItemTap(item, i)"
        >
          <p>{{ item.text }}</p>
          <span v-if="item.num">({{ item.num }})</span>
        </div>
      </div>
    </div>
    <div :style="{height: navIndex?'4rem':'2.5rem'}"></div>
    <my-release v-show="navIndex == 0"></my-release>
    <my-receive v-show="navIndex == 1" ref="myReceive" :status="status"></my-receive>
    <!-- <taskList @receive="receive($event)"></taskList> -->
    <!-- 筛选框 -->
  </div>
</template>

<script>
import MyTabs from "@/components/my-tabs.vue";
// import taskList from "./components/taskList.vue";
import myRelease from "./components/myRelease.vue";
import myReceive from "./components/myReceive.vue";
import { countTaskApi } from "@/api/api/task.js";
export default {
  components: {
    MyTabs,
    myRelease,
    myReceive,
    // taskList,
  },
  data() {
    return {
      navList: [
        {
          text: "已发布",
          num: null,
        },
        {
          text: "已领取",
          num: null,
        },
      ],
      navIndex: 0,
      receiveNavList: [
        {
          text: "进行中",
          num: null,
          status: "1",
        },
        {
          text: "评审中",
          num: null,
          status: "2",
        },
        {
          text: "付款中",
          num: null,
          status: "3",
        },
        {
          text: "已关闭",
          num: null,
          status: "4",
        },
        {
          text: "已中止",
          num: null,
          status: "5",
        },
      ],
      status: "1",
      receiveNavIndex: 0,
      screenShow: false,
      searchVal: "",
      receiveDialogShow: false,
    };
  },
  created() {
    this.getCountTask();
  },
  methods: {
    async getCountTask() {
      let res = await countTaskApi();
      let data = res.data.data;
      this.navList[0].num = data.publishCount;
      this.navList[1].num = data.myTasksCount;
      if (res.data.errorCode != 0) {
        // this.receiveNavList[0].num = data.tasksdata.jxz_num;
        // this.receiveNavList[1].num = data.tasksdata.psz_num;
        // this.receiveNavList[2].num = data.tasksdata.fkz_num;
        // this.receiveNavList[3].num = data.tasksdata.ygb_num;
        // this.receiveNavList[4].num = data.tasksdata.yzz_num;
      }
    },
    screenConfirm() {
      this.screenShow = false;
    },
    receive(e) {
      console.log(e);
      this.receiveDialogShow = true;
    },

    receiveNavItemTap(item, i) {
      this.receiveNavIndex = i;
      this.status = item.status;
      // setTimeout(() => {
      //   this.$refs.myReceive.getData();
      // }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.task {
  width: 100%;
  min-height: 100%;
  padding-bottom: 65px;

  .receiveNav {
    width: 345px;
    height: 61px;
    background-color: #fff;
    margin-left: 15px;
    border-bottom: 1px solid #d8d8d8;
    display: flex;
    justify-content: space-between;

    .receiveNavItem {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #979797;
      font-size: 13px;
      p {
        margin-bottom: 5px;
      }
    }
    .receiveNavItemActive {
      color: #0286ff;
    }
  }
}
</style>
